import "./jquery/jstree/jquery.jstree.js"
import "./bootstrap/admission.js"
